module.exports = __webpack_public_path__ + "static/media/MedEd_Search_Blank.0f090a0d.png";